import type { Components, Theme } from '@mui/material/styles';

export const buttonCustomizations: Components<Theme> = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true,
    },
  },
};
